<script lang="ts">
  import type { TravelerConnectionQuery } from '$lib/content-queries/generated/QueryTravelers'

  export let traveler: TravelerConnectionQuery['travelersConnection']['edges'][0]['node']
</script>

<li>
  <a href={`/@${traveler.handle}`} class="space-y-2 text-sm font-medium lg:text-sm">
    <img
      class="w-20 h-20 mx-auto rounded-full lg:hidden"
      src={traveler?.avatar?.url}
      alt={traveler?.avatar?.id}
      height={80}
      width={80}
    />
    <img
      class="hidden lg:block mx-auto rounded-full w-24 h-24"
      src={traveler?.avatar?.url}
      alt={traveler?.avatar?.id}
      height={96}
      width={96}
    />

    <h3 class="flex flex-col">
      <span>{traveler.fullName}</span>
      <span class="text-xs font-light text-brand-secondary">@{traveler.handle}</span>
    </h3>
  </a>
</li>
